module.exports = __webpack_public_path__ + "img/contentImgHover4.5a05caf.png";